// Copyright (c) 2022 Deere & Company

/*

when listening for messages, we may pick up on a lot of noise and unexpected messages.
The purpose of this function is to make sure that messages which do not match the
expected format are handled gracefully.

*/

export const parseMessage = message => {

    try {

        return JSON.parse(message);

    } catch (e) {

        return {};

    }

};



// WEBPACK FOOTER //
// ./src/shared/services/parse-message.js